<template>
    <common-fuzzy :param="param" :obj="obj" @change="cb"></common-fuzzy>
</template>

<script>
    import help from '@/util/help'

    export default {
        props: ['obj'],
        data() {
            return {
                param: {
                    api: 'manage/advertisingPlace/findAdvertisingPlacePage',
                    // query: {
                    //     level:2,
                    // },
                    cols: [
                        {
                            key: 'placeCode',
                            value: '编码',
                            minWidth: 100,
                            searchNormal: true,
                        },
                        {
                            key: 'placeName',
                            value: '名称',
                            minWidth: 100,
                            searchNormal: true,
                        },
                    ],
                }
            }
        },
        inject: ['ins'],
        methods: {
            cb(data) {
                help.execFuncByParent(this, 'fuzzyAdvertisingPlace', data);
            },
        }
    }
</script>

<style scoped>

</style>
